import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var e = /*#__PURE__*/function () {
  function e() {
    _classCallCheck(this, e);

    this.objectIdFieldName = null, this.globalIdFieldName = null, this.geohashFieldName = null, this.geometryProperties = null, this.geometryType = null, this.spatialReference = null, this.hasZ = !1, this.hasM = !1, this.features = [], this.fields = [], this.transform = null, this.exceededTransferLimit = !1, this.uniqueIdField = null, this.queryGeometryType = null, this.queryGeometry = null;
  }

  _createClass(e, [{
    key: "weakClone",
    value: function weakClone() {
      var t = new e();
      return t.objectIdFieldName = this.objectIdFieldName, t.globalIdFieldName = this.globalIdFieldName, t.geohashFieldName = this.geohashFieldName, t.geometryProperties = this.geometryProperties, t.geometryType = this.geometryType, t.spatialReference = this.spatialReference, t.hasZ = this.hasZ, t.hasM = this.hasM, t.features = this.features, t.fields = this.fields, t.transform = this.transform, t.exceededTransferLimit = this.exceededTransferLimit, t.uniqueIdField = this.uniqueIdField, t.queryGeometry = this.queryGeometry, t.queryGeometryType = this.queryGeometryType, t;
    }
  }]);

  return e;
}();

export { e as default };